import { render } from "./raceCreate.vue?vue&type=template&id=23ca2e82&scoped=true"
import script from "./raceCreate.vue?vue&type=script&lang=js"
export * from "./raceCreate.vue?vue&type=script&lang=js"

import "./raceCreate.vue?vue&type=style&index=0&id=23ca2e82&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ca2e82"]])

export default __exports__